import React, { Component } from 'react'
import Footer from './Footer.jsx'
import Windrose from './Windrose.jsx'
import WindroseTable from './WindroseTable.jsx'
import ObtainData from './ObtainData.jsx'
import NavDrawer from './NavDrawer.jsx'

export default class App extends Component {
  constructor() {
    super()
    this.state = {
      highChartOptions: { series: null },
      windtableData: null,
      userParams: null,
      showResults: null
    }
  }

  loadWindRoseData = (windroseData, windtableData, stnName) => {
    let dayFilter = "", hourFilter = ""
    const sd = [this.state.userParams.fromFilterMonth, this.state.userParams.fromFilterDay].join("-")
    const ed = [this.state.userParams.toFilterMonth, this.state.userParams.toFilterDay].join("-")
    if (sd !== '01-01' || ed !== '12-31') {
      dayFilter = 'Day filter: ' + sd + " through " + ed
    }
    if (this.state.userParams.fromFilterHour !== 1 || this.state.userParams.toFilterHour !== 24) {
      hourFilter = 'Hour filter: ' + this.state.userParams.fromFilterHour + "-" + this.state.userParams.toFilterHour
    }
    const subtitleText = this.state.userParams.pctcnt.charAt(0).toUpperCase() + this.state.userParams.pctcnt.slice(1) + 
          " of winds blowing from the indicated direction" +
          "<br />Date range: " + this.state.userParams.fromDate + " through " + this.state.userParams.toDate +
          "<br />" + dayFilter + (dayFilter && hourFilter ? "; " : "") + hourFilter
    this.setState({
      highChartOptions: {
        series: windroseData, 
        title: {text: stnName}, 
        subtitle: {text: subtitleText},
      }, 
      windtableData: {...windtableData, dayFilter:dayFilter, hourFilter:hourFilter}
    })
  }

  startRequest = (params) => {
    this.setState({
      highChartOptions:{ series:null }, 
      userParams:params,
      showResults: true
   })
  }

  showResults = (tf) => {
    this.setState({showResults: tf})
  }

  render() {
    return (
      <div className="app">
        <NavDrawer 
          startRequest={this.startRequest}
          userParams={this.state.userParams}
          showResults={this.showResults}
        />
        {this.state.userParams &&
          <ObtainData 
            loadWindRoseData={this.loadWindRoseData} 
            userParams={this.state.userParams}
          />
        }
        {this.state.highChartOptions.series && this.state.showResults &&
          <Windrose 
            options={this.state.highChartOptions}
            userParams={this.state.userParams}
          />
        }
        {this.state.highChartOptions.series && this.state.showResults &&
          <WindroseTable 
            hcdata={this.state.highChartOptions}
            userParams={this.state.userParams}
            windtableData={this.state.windtableData}
          />
        }
        <Footer />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/App.jsx